import React from "react";
import { PropTypes } from 'prop-types';
import {
  InputWrapper,
  EmailWrapper,
  FormItemWrapper
} from "../../Step1Setup/styles";
import { EmailTitleWrapperFont, PercentageTitle } from "../styles";
import { Form } from "antd";
import { MarginSpecific } from "./styles";
import { InputField } from "../../../../../CommonComponents/commonStyles";

export const InputComponent = props => {
  const { getFieldDecorator } = props.form;
  let input_title = props.title ? props.title : '';
  return (
    <FormItemWrapper
      colon={false}
      label={
        props.title === "Percentage" ? (
          <PercentageTitle>{props.title}</PercentageTitle>
        ) : (
          <MarginSpecific paddingTop="2px">
            <EmailWrapper>
              <EmailTitleWrapperFont>{props.title}</EmailTitleWrapperFont>
            </EmailWrapper>
          </MarginSpecific>
        )
      }
    >
      {getFieldDecorator(`input${ input_title }${props.id}`, {
        rules: [
          {
            type: "string"
          }
        ]
      })(
        <InputWrapper>
          <InputField
            aria-label={props.ariaLabel}
            width = {false}
            aria-label={props.ariaLabel}
            id={props.id && ("txtStep2Input"+props.id+input_title)}
            maxLength={props.max}
            onBlur={props.handleBlur}
            title={props.hoverTitle}
            onBlur={props.handleBlur}
            value={props.value}
            onChange={props.handleInputChange}
            placeholder={props.placeholder}
            disabled={props.disabled ? props.disabled : null}
            ref={props.inputRef ? props.inputRef : null}
          />
        </InputWrapper>
      )}
    </FormItemWrapper>
  );
};

const WrappedInputComponent = Form.create({ name: "input" })(InputComponent);

InputComponent.propTypes = {
  form: PropTypes.object,
  handleBlur: PropTypes.func,
  handleInputChange: PropTypes.func,
  max: PropTypes.number,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any
}

export default WrappedInputComponent;
